export function getImgByCardSize(imageData, cardSize) {
    return cardSize === 'large' ? imageData.cloud_img_lrg : imageData.cloud_img_med_alt;
}

export function getImgThumbUrl(img) {
    return img.match(/(src=")([^"]*)(")/g)[0].replace('src=', '').replace(/"/g, '');
}

export function getImgSrcSet(img) {
    return img.match(/(srcset=")([^"]*)(")/g)[0].replace('srcset=', '').replace(/"/g, '');
}

export function getMediaId(url) {
    return url.match(/\d+/g)[0];
}



// WEBPACK FOOTER //
// ./src/shared/media/helpers.js